<script setup lang="ts">
const { items } = defineProps<{
  items: {
    component: string
    _uid: string
  }[]
}>()

function getComponent(component: string) {
  return component.startsWith('Page') && component !== 'PageBlock' ? component : `Component${component}`
}
</script>

<template>
  <div>
    <component v-bind="item" :is="getComponent(item.component)" v-for="item in items" :key="item._uid" v-editable="item" />
  </div>
</template>
